export const CreateAccountUrl = 'Accounts/CreateAccount';
export const DocumentsUploadUrl = 'Documents/Uploads';
export const UserRequirementsUrl = 'User/GetRequirements';
export const GetHeardAboutUrl = (siteConfigId) => siteConfigId ? `Accounts/GetHeardAbout?siteConfigId=${siteConfigId}` : 'Accounts/GetHeardAbout';
export const GetApplicationInvestigationStatusUrl = (accountId) => `Investigations/${accountId}/Investigation`;
export const UploadInvestigationDocumentUrl = (accountId, investigationId) => `Documents/${accountId}/Uploads/Investigations/${investigationId}`;
export const UploadApplicationDocumentUrl = (accountId, accountHolderId) => `Documents/${accountId}/Uploads/Application/${accountHolderId}`;
export const UploadMiscellaneousDocumentsUrl = (accountId) => `Documents/${accountId}/Uploads/Miscellaneous`;
export const GetMiscellaneousDocumentsUrl = (accountId, documentId) => `Documents/${accountId}/Uploads/Miscellaneous/${documentId}`;
export const GetMiscellaneousDocumentsMetadataUrl = (accountId, documentId) => `Documents/${accountId}/Uploads/Miscellaneous/${documentId}/Metadata`;
export const DuplicateAccountCheckUrl = 'Accounts/DuplicateAccountCheck';
export const UploadCashieringDocumentUrl = (accountId, instructionId) => `Documents/${accountId}/Uploads/TransferInstructions/Wires/${instructionId}`;
export const GetTransferInstructionsDocumentsIdUrl = (accountId, instructionId) => `Documents/${accountId}/Uploads/TransferInstructions/Wires/${instructionId}/Documents`;
export const GetTransferInstructionsDocumentUrl = (accountId, instructionId, documentId) => `Documents/${accountId}/Uploads/TransferInstructions/Wires/${instructionId}/${documentId}`;
export const GetTransferInstructionsDocumentMetadataUrl = (accountId, instructionId, documentId) => `Documents/${accountId}/Uploads/TransferInstructions/Wires/${instructionId}/${documentId}/Metadata`;
export const CreateUserUrl = 'User/CreateUser';
export const GetSymbolsUrl = 'Symbol/Search';
export const PlaceOrderUrl = 'Orders/PlaceOrder';
export const ChangeOrderUrl = 'Orders/ChangeOrder';
export const CancelOrderUrl = 'Orders/CancelOrder';
export const GetOrdersUrl = 'Orders/GetOrders';
export const SearchOrdersUrl = (accountId) => `Orders/accounts/${accountId}/orders/search`;
export const PositionsUrl = 'Positions/GetPositions';
export const HistoryGetHistoryUrl = 'History/GetHistory';
export const HistoryGetHistoryBalances = 'History/GetBalanceHistory';
export const HistoryGetBalancesEndpoint = 'History/GetBalances';
//post function set:
export const TokenRequestUrl = 'Auth/token';
/**
 * On server-side `POST Auth/token`, apiserver sends the derived end-user IP using this header name so RestHub
 * can attribute login history to the browser session. Matches Cloudflare’s visitor header name for consistency;
 * value is still **server-derived** in apiserver (see `resolveClientIpForRestHub`), not copied from the browser.
 */
export const TB_END_USER_IP_HEADER = 'CF-Connecting-IP';
export const LogoutTokenUrl = 'Auth/LogoutToken';
export const SubmitMktDataUserProfileReviewUrl = 'User/SubmitMktDataUserProfileReview';
export const TokenCheckUrl = 'Auth/TokenCheck';
//get function set:
export const GetBalancesUrl = 'Balances/GetBalances'; //?accountId={0}&subaccountId={1}
export const GetBalancesForAccountsURL = 'Balances/GetBalancesForAccounts'; //?items={[{accountId:0,subaccountId:1},{accountId:2,subaccountId:3}]}
export const GetBalancesForWithdrawalURL = (accountId) => `Cashiering/${accountId}/Balances`;
export const GetAvailableFundsUrl = 'Balances/GetAvailableFunds'; //?accountId={0}&subaccountId={1}
export const GetExpirationsUrl = 'Chains/GetExpirations'; //?underlyingSymbol={0}
export const GetAccountsUrl = 'Accounts/GetAccounts'; //?accountId={0}&subaccountId={1}
export const GetSubaccountsUrl = 'Accounts/GetSubaccounts'; //?accountId={0}&subaccountId={1}
export const GetAccountDetailsUrl = 'Accounts/GetAccountDetails'; //?accountId={0}
export const AccountsSearchUrl = 'Accounts/SearchAccounts';
export const GetAccountUpdateUrl = 'Accounts/GetAccountUpdate'; //?confirm={0}
export const SearchAccountUpdatesUrl = 'Accounts/SearchAccountUpdates'; //?states={0} && items && search && startDate && endDate && sortBy && sortByOrder && page && pagesize
export const GetAccountUpdateDetailsUrl = 'Accounts/GetAccountUpdateDetail';
export const GetAccountManagementDetailsUrl = 'Accounts/GetAccountManagementDetails';
export const GetPendingUserMarketDataEntitlementsUrl = 'User/GetPendingUserMarketDataEntitlements'; //?page={0}&pagesize={1}
export const GetPendingAccountManagementUpdatesUrl = '/Accounts/PendingAccountUpdates'; //?accountId={0}
export const GetDocumentStatusUrl = 'Accounts/GetDocumentStatus';
export const GetUserMarketDataEntitlementsUrl = 'User/GetUserMarketDataEntitlements';
export const GetPendingUserMarketDataEntitlementDetailsUrl = 'User/GetPendingUserMarketDataEntitlementDetails'; //?pendingId={0}
// put function set:
export const ConfirmAccountUpdateUrl = 'Accounts/ConfirmAccountUpdate'; //?confirm={0}
export const UpdateAccountUrl = 'Accounts/UpdateAccount'; //?accountId={0}
export const FirmApproveAccountUpdateUrl = 'Accounts/FirmApproveAccountUpdate';
export const FirmRejectAccountUpdateUrl = 'Accounts/FirmRejectAccountUpdate';
//?underlyingSymbol={0}
// &rootSymbol={1}&expiration={2}&strikeMin={3}&strikeMax={4}&fetchGreeks=true/false
//{1} {2} ... {5} are optional
export const GetChainUrl = 'Chains/GetChain';
//?underlyingSymbol={0}&expiration={1}
export const GetStrikesUrl = 'Chains/GetStrikes';
//?symbol={0}&starttime={1}&endtime={2}&period={3}
//symbol, "01-01-2010", "03-29-2019", "Day"
export const GetBarsUrl = 'Quotes/GetBars';
//?symbols={0}
//sample {0}=FB,TSLA,AMZN,NVDA
//this returns a list of position lot
export const GetQuoteUrl = 'Quotes/GetQuotes';
export const GetQuoteExtendedUrl = 'Symbol/GetCompanyStats';
export const GetQuoteDividendUrl = `Symbol/GetDividends`;
export const GetQuoteEarningsUrl = `Symbol/GetEarnings`;
//?spreads={0}
//sample {0}=[{"Legs":[{"Symbol":".PANW 181019C205000","AssetType":2,"LegBid":0.0,"LegAsk":0.0},{"Symbol":".PANW 181019C207500","AssetType":2,"LegBid":0.0,"LegAsk":0.0}],"Bid":0.0,"Ask":0.0,"Last":0.0,"Change":0.0,"Type":2,"SpreadTime":"0001-01-01T00:00:00"}]
export const GetSpreadQuotesUrl = 'Quotes/GetSpreadQuotes';
//?accountId={0}&subaccountId={1}&dateFrom={2}&dateTo={3}&pageSize={4}&pageIndex={5}
// {1} {2} ... {5} are all optional
export const GetPnLUrl = 'History/GetPnL';
//?accountId={0}&subaccountId={1}
//this returns a list of position lot
export const GetPositionsUrl = 'Positions/GetPositions';
export const SymbolsWithAMPMExpirations = ['$SPX', '$VIX'];
export const GetReleaseNotesUrl = '/SystemNotices';
export const CreateReleaseNotesUrl = '/SystemNotices/Templates';
export const UpdateReleaseNotesUrl = (id) => `/SystemNotices/Templates/${id}`;
export const GetNewsFeedUrl = 'Symbol/GetNews';
export const AlertMessagesURL = '/AlertMessages';
export const GetAlertMessageTemplatesURL = '/AlertMessages/Templates';
export const UpdateAlertsURL = (id, active) => `/AlertMessages/Templates/${id}`;
// Password Reset Get Routes
export const GetSecurityChallengeUrl = 'User/GetSecurityChallenge';
export const MarketScheduleURL = '/MarketSchedule';
// Password Reset Post Routes
export const VerifySecurityChallengeUrl = 'User/VerifySecurityChallenge';
export const PasswordChangeInitiateUrl = 'User/PasswordChangeInitiate';
export const PasswordChangeFinalizeUrl = 'User/PasswordChangeFinalize';
export const PasswordChangeUrl = 'User/PasswordChange';
//Downloads endpoints for statements
export const DownloadsDailyConfirms = (accountId) => `Downloads/${accountId}/DailyConfirms`;
export const DownloadsDailyConfirm = (accountId) => `Downloads/${accountId}/DailyConfirm`;
export const DownloadsMonthlyStatements = (accountId) => `/Downloads/${accountId}/MonthlyStatements`;
export const DownloadsMonthlyStatement = (accountId) => `/Downloads/${accountId}/MonthlyStatement`;
export const DownloadsTaxDocuments = (accountId, form) => `/Downloads/${accountId}/TaxDocuments/${form}`;
export const DownloadsTaxDocument = (accountId, form) => `/Downloads/${accountId}/TaxDocument/${form}`;
export const GetLoginHistory = 'User/GetLoginHistory';
// Two-factor Authentication
export const VerifyTwoFactorAuthenticationMethodUrl = 'User/Verify2FaContact';
export const GetTwoFactorAuthenticationDetailsUrl = 'User/Get2FaDetails';
export const GENERIC_ACCOUNT_ISSUE_ERROR_MSG = 'There is an issue with your account. Please contact our Customer Service team.';
export const GENERIC_LOGIN_ERROR_MSG = 'There was an issue logging in. Please try again.';
export const TOO_MANY_REQUESTS_ERROR_MSG = 'You have exceeded the number of requests allowed. Please try again in a few minutes. If the issue persists, please contact Customer Service.';
export const ISSUE_SENDING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG = 'We encountered an issue sending the security code. Please click the button to request a new code. If the issue persists, please contact Customer Service.';
export const ISSUE_SUBMITTING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG = 'There was an issue submitting the security code. Please click the button to request a new code. If the issue persists, please contact Customer Service.';
//# sourceMappingURL=constants.js.map